
export const CASE_INFO_DIRECTORY = 'case-info';
export const IMAGE_FIELDS = ['image'];